// extracted by mini-css-extract-plugin
module.exports = {"trash":"_2Is0k___ModelList-module__trash","row":"_36IDF___ModelList-module__row"};